webpackJsonp([140],{

/***/ 2549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__(3166);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5a59be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__ = __webpack_require__(3671);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3669)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5a59be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/carousel/Carousel.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3b5a59be", Component.options)
  } else {
    hotAPI.reload("data-v-3b5a59be", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            index: 0,
            slides: [],
            slideDirection: ''
        };
    },

    computed: {
        slidesLength: function slidesLength() {
            return this.slides.length;
        }
    },
    mounted: function mounted() {
        this.$children.pop();
        this.$children.pop();
        this.slides = this.$children;
        this.slides.map(function (slide, index) {
            slide.index = index;
        });
        // window.setInterval(() => {
        //     this.next()
        // }, 7000)
    },

    methods: {
        next: function next() {
            this.index++;
            if (this.index >= this.slidesLength) {
                this.index = 0;
            }
            this.slideDirection = 'slide-right';
        },
        prev: function prev() {
            this.index--;
            if (this.index < 0) {
                this.index = this.slidesLength - 1;
            }
            this.slideDirection = 'slide-left';
        },
        checkSlide: function checkSlide(event) {
            if (event.keyCode === 26) {
                this.next();
            } else if (event.keyCode === 26) {
                this.prev();
            } else {}
        }
    }
});

/***/ }),

/***/ 3669:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3670);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("212fefd3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3b5a59be\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Carousel.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3b5a59be\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Carousel.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3670:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n@media only screen and (min-width: 1024px){\n.carousel{position:relative;overflow:initial\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.carousel{position:relative;overflow:initial\n}\n}\n@media only screen and (max-width: 575px){\n.carousel{position:initial;overflow:initial\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.carousel{position:initial;overflow:initial\n}\n}\n.btn2{top:12rem;background-color:transparent;border:0px solid transparent;color:#000;position:absolute;z-index:2\n}\n@media only screen and (max-width: 575px){\n.btn2{top:15rem !important;padding:5rem 3rem;margin-bottom:3rem;min-height:280px\n}\n}\n.button-line{position:relative;border-top:1px solid black;vertical-align:bottom;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;top:2rem\n}\n.btn:hover{cursor:pointer\n}\n.btn:focus{outline:none\n}\n.btn-next2{vertical-align:bottom\n}\n@media only screen and (min-width: 1024px){\n.btn-next2{left:0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.btn-next2{left:0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.btn-next2{left:0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (max-width: 575px){\n.btn-next2{left:0;-webkit-transform:rotate(-180deg);transform:rotate(-180deg)\n}\n}\n.btn-prev2{vertical-align:bottom\n}\n@media only screen and (min-width: 1024px){\n.btn-prev2{right:0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.btn-prev2{right:0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.btn-prev2{right:0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (max-width: 575px){\n.btn-prev2{right:0\n}\n}\n.carousel-slider{position:absolute\n}\n.carousel-slider img{width:60%;height:60%;border-radius:50%\n}\n", ""]);

// exports


/***/ }),

/***/ 3671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { tabindex: "0" },
      on: {
        keydown: function($event) {
          return _vm.checkSlide($event)
        }
      }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "btn2 btn-next2",
            staticStyle: {
              "background-color": "transparent",
              border: "0px solid transparent"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.next.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "i",
              { staticClass: "fa fa-angle-right" },
              [
                _c("base-icon", {
                  staticClass: "ml-2",
                  attrs: {
                    width: "50",
                    height: "50",
                    src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                    color: "blue"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn2 btn-prev2",
            staticStyle: {
              "background-color": "transparent",
              border: "0px solid transparent"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.prev.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "i",
              { staticClass: "fa fa-angle-right" },
              [
                _c("base-icon", {
                  staticClass: "ml-2",
                  attrs: {
                    width: "50",
                    height: "50",
                    src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                    color: "blue"
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b5a59be", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/140.7abb8504c71956432656.js